import { render, staticRenderFns } from "./AddictiveStuffClientInfo.vue?vue&type=template&id=5890de09&scoped=true&"
import script from "./AddictiveStuffClientInfo.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5890de09",
  null
  
)

export default component.exports